import angular from 'angular';

export class DocumentoColaboradorModalService {
	static $inject = ['$uibModal'];

	constructor(public $uibModal: ng.ui.bootstrap.IModalService) { }

	open(subentity: any) {
		return this.$uibModal.open({
			template: require('html-loader!./anexos.visualizarmodal.html'),
			controller: [
				'entity',
				'$uibModalInstance',
				'$sce',
				function TrabalhadorModal(
					entity: any,
					$uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
					$sce: angular.ISCEService
				) {
					let selfModal = this;
					selfModal.entity = entity;

                    if (!selfModal.entity.possuibin) {
                        selfModal.entity.urldocumento = $sce.trustAsResourceUrl(selfModal.entity.urldocumento);
                    }

					selfModal.close = () => $uibModalInstance.close();
				}
			],
			controllerAs: '$ctrl',
			windowClass: 'nsj-modal-lg',
			resolve: {
				entity: () => angular.copy(subentity)
			}
		});
	}
}
